export type SendMailProps = {
  Title: string;
  docCode: string;
  contents: string[];
  dateFrom: string;
  dateTo: string;
  message: string;
  url: string;
  userDisplayName: string;
  userEmail: string;
};

export type MailDocumentType = {
  docCode: string;
  Title: string;
  docPublishViewVersion: string;
  docEditionVersion: string;
  startDate: string;
  url: string;
};

export type PublishMultipleFileMailProps = {
  listDocument: MailDocumentType[];
  message: string;
  userDisplayName: string;
  userEmail: string;
  publishDepartment: string;
};

export function mailComposeTemplate(items: SendMailProps) {
  const { Title, docCode, contents, dateFrom, dateTo, message, url, userDisplayName, userEmail } = items;
  return `<div class="container">
                  <p>Kính gửi Anh/Chị,</p>
                  <p>
                      - Anh/Chị vừa nhận được thông báo từ: Chương trình
                      <span class="highlight">HỆ THỐNG QUẢN LÝ TÀI LIỆU VIAGS</span>
                  </p>
                  <p>
                      - Nội dung: Phân quyền soạn thảo trên tài liệu
                      <span class="highlight">${Title}</span>, Mã tài liệu
                      <span class="highlight">${docCode}</span>
                  </p>
                  <div class="content">
                      ${contents.map((item) => `<p>${item}</p>`).join("")}
                      <p>Thời gian thực hiện: ${dateFrom} - ${dateTo}</p>
                      <p>Mô tả: <span class="highlight">${message}</span></p>
                      <p>
                          <em
                              >(Vui lòng xem thông tin chi tiết trong chương trình
                              <a href="${url}">tại đây</a>)</em
                          >
                      </p>
                  </div>
                  <p>Người gửi: ${userDisplayName}</p>
                  <p> - Điện thoại: </p>
                  <p> - Email: <a href="mailto:${userEmail}">${userEmail}</a> </p>
              </div>
              <div>-------------------------------------------------------------------</div>
              <div class="footer">
                  <bold>VIAGS Eoffice - Công Ty Dịch Vụ Mặt Đất Sân Bay Việt Nam</bold>
              </div>
          `;
}

export function mailPublishMultipleFile(items: PublishMultipleFileMailProps) {
  const { listDocument, message, userDisplayName, userEmail, publishDepartment } = items;
  return `<!DOCTYPE html>
          <html lang="vi">
              <head>
                  <meta charset="UTF-8" />
                  <meta
                      name="viewport"
                      content="width=device-width, initial-scale=1.0"
                  />
                  <title>Thông Báo 4</title>
                  <style>
                      body {
                          font-family: Arial, sans-serif;
                          line-height: 1.6;
                      }
                      .container {
                          width: 100%;
                      }
                      .content {
                          background-color: #f9f9f9;
                          border-radius: 8px;
                          border: 1px solid #ddd;
                      }
                      .highlight {
                          font-weight: bold;
                      }
                      table,
                      th,
                      td {
                          border: 1px solid black;
                          border-collapse: collapse;
                      }
                  </style>
              </head>
              <body>
                  <div class="container">
                      <p>Kính gửi Anh/Chị,</p>
                      <p>
                          - Anh/Chị vừa nhận được thông báo từ: Chương trình
                          <span class="highlight"
                              >HỆ THỐNG QUẢN LÝ TÀI LIỆU VIAGS</span
                          >
                      </p>
                      <p>
                          - Nội dung: Ban hành/Cập nhật tài liệu
  
                          <span class="highlight">${publishDepartment}</span>
                      </p>
                      <p>- Chi tiết:</p>
                      <div class="content">
                          <table border="">
                              <tr>
                                  <th style="padding: 0 16px">STT</th>
                                  <th style="padding: 0 24px">Mã tài liệu</th>
                                  <th style="padding: 0 24px">Tên tài liệu</th>
                                  <th style="padding: 0 24px">Lần ban hành</th>
                                  <th style="padding: 0 24px">Lần sửa đổi</th>
                                  <th style="padding: 0 24px">
                                      <span>Ngày hiệu lực</span> <br />
                                  </th>
                              </tr>
                              ${listDocument
                                .map(
                                  (document, index) => `
                                  <tr>
                                      <td
                                          style="
                                              padding: 0 16px;
  
                                              text-align: center;
                                          "
                                      >
                                          ${index + 1}
                                      </td>
                                      <td style="padding: 0 24px">${document.docCode}</td>
                                      <td style="padding: 0 24px"><a href="${document.url}">${document.Title}</a></td>
                                      <td style="padding: 0 24px">${document.docPublishViewVersion}</td>
                                      <td style="padding: 0 24px">${document.docEditionVersion}</td>
                                      <td style="padding: 0 24px">${document.startDate}</td>
                                  </tr>
                              `,
                                )
                                .join("")}
                          </table>
                      </div>
                      <span style="margin-top: 16px; display: inline-block">Mô tả: <bold>${message}</bold></span>
                      <p>
                          <em
                              >(Vui lòng xem thông tin chi tiết trong chương trình
                            và xác nhận triển
                              khai)</em
                          >
                      </p>
                  <div style="margin-top: 12px">
                  <p>Người gửi: ${userDisplayName}</p>
                  <p>   - Điện thoại: </p>
                  <p>   - Email: <a href="mailto: ${userEmail}">${userEmail}</a></p>
              </div>
          </div>
          <p>-------------------------------------------------------------------------------------</p>
              <div class="footer">
                  <bold>VIAGS Eoffice - Công Ty Dịch Vụ Mặt Đất Sân Bay Việt Nam</bold>
              </div>
      </body>`;
}
